export class Role {
  name?: string;
  displayName?: string;

  constructor(role) {
    this.name = role.name;
    this.displayName = role.displayName;
  }
}
